module.exports = __webpack_public_path__ + "img/bowl-chopsticks-noodles.ba8a0274.svg";